import * as enRes from './translations/localization.en.json';
import * as ruRes from './translations/localization.ru.json';
// todo dynamic import resources

export class LocaleProvider {
  private static _instance: LocaleProvider;
  private resouces = {
    en: enRes,
    ru: ruRes,
  };
  private lang = [
    { id: 0, langCode: 'bg', name: 'Bulgarian' },
    { id: 1, langCode: 'cs', name: 'Czech' },
    { id: 2, langCode: 'de', name: 'German' },
    { id: 3, langCode: 'en', name: 'English' },
    { id: 4, langCode: 'es', name: 'Spanish' },
    { id: 5, langCode: 'fr', name: 'French' },
    { id: 6, langCode: 'it', name: 'Italian' },
    { id: 8, langCode: 'pl', name: 'Polish' },
    { id: 9, langCode: 'pt', name: 'Portuguese' },
    { id: 10, langCode: 'ro', name: 'Romanian' },
    { id: 11, langCode: 'ru', name: 'Русский' },
    { id: 12, langCode: 'sr', name: 'Serbian' },
    { id: 13, langCode: 'tr', name: 'Turkish' }
  ];
  public static get Instance() {
    // Do you need arguments? Make it a regular static method instead.
    return this._instance || (this._instance = new this());
  }
  get currentLang() {
    if(!localStorage)
      return 'en';
    const loc = localStorage.getItem('locale') || 'en';
    if (loc == 'undefined') {
      return 'en';
    }
    return (this.resouces as any)[loc] ? loc : 'en';
  }
  set currentLang(value: string) {
    if(localStorage)
      localStorage.setItem('locale', value);
  }
  get localeResource(): Object {
    return (this.resouces as any)[this.currentLang];
  }
  getTranslate(key: string) {
    const res = this.localeResource;
    if (!res) {
      console.error(`Ресурсы ключа: ${key} для языка ${this.currentLang} не найдены!`);
      return key;
    }
    if (!res.hasOwnProperty(key)) {
      console.error(`Ресурсы ключа: ${key} для языка ${this.currentLang} не найдены!`);
      return key;
    }
    return (res as any)[key];
  }
  getLangCodeById(id: number): string {
    return this.lang.find((item) => item.id == id).langCode;
  }
  getLangNameById(id: number): string {
    return this.lang.find((item) => item.id == id).name;
  }
  getLangObjectById(id: number): { id: number; langCode: string; name: string } {
    return this.lang.find((item) => item.id == id);
  }
  getLangCodes(): string[] {
    return this.lang.map((item) => item.langCode);
  }
}

const myClassInstance = LocaleProvider.Instance;
export default myClassInstance;
